import usePresenter from './presenter';

export const Callback = (props) => {
  usePresenter(props);

  return null;
};
